import { COMMERCIAL_BILLING_NAV_KEYS } from '@/components/SiderMenu/utils/sessionNavigation';

/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'billingSubscriptions';

/**
 * Descriptor-only route token (export/tasks disabled).
 * Runtime list/detail base path comes from session navigation (commercial billing).
 */
export const FETCH_ROUTE = 'billing-subscriptions';

/** Singular entity name for shared helpers / notifications. */
export const ENTITY_NAME = 'billingSubscription';

/** Fixed Automy-owner administration API; tenant OData remains read-only. */
export const ADMINISTRATION_API_ROUTE = 'billing/subscriptions';

export const SUBSCRIPTION_ADMINISTRATION_ACTION = Object.freeze({
  SUSPEND: 'suspend',
  REACTIVATE: 'reactivate',
});

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'billingSubscriptions';

/** Default OData sort when the user clears column sorting. */
export const DEFAULT_ORDER_BY = 'company/commercialName asc';

/** Session navigation key used to resolve the commercial billing API base path. */
export const NAVIGATION_KEY = COMMERCIAL_BILLING_NAV_KEYS.SUBSCRIPTIONS;
